import {
  InputAddress,
  PayloadAddress,
  SearchAddress,
} from '../reducers/addressReducer'

export const ACTIONS = {
  SAVE_SEARCH_ADDRESS: 'SAVE_SEARCH_ADDRESS',
  SAVE_INPUT_ADDRESS: 'SAVE_INPUT_ADDRESS',
  RESET_INPUT_ADDRESS: 'RESET_INPUT_ADDRESS',
  SAVE_PAYLOAD_ADDRESS: 'SAVE_PAYLOAD_ADDRESS',
}

export const SAVE_SEARCH_ADDRESS = (
  search: SearchAddress,
  addressType: 'billing' | 'shipping'
) => ({
  type: ACTIONS.SAVE_SEARCH_ADDRESS,
  search,
  addressType,
})

export const SAVE_INPUT_ADDRESS = (
  input: InputAddress,
  isPanelOpen: boolean,
  addressType: 'billing' | 'shipping'
) => ({
  type: ACTIONS.SAVE_INPUT_ADDRESS,
  input,
  isPanelOpen,
  addressType,
})

export const SAVE_PAYLOAD_ADDRESS = (
  isValid: boolean,
  payload: PayloadAddress,
  addressType: 'billing' | 'shipping'
) => ({
  type: ACTIONS.SAVE_PAYLOAD_ADDRESS,
  isValid,
  payload,
  addressType,
})

export const RESET_INPUT_ADDRESS = (addressType: 'billing' | 'shipping') => ({
  type: ACTIONS.RESET_INPUT_ADDRESS,
  addressType,
})
